function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';

const UndrawSetupWizard = _props => {
  const props = Object.assign({}, _props);
  const primaryColor = props.primaryColor || defaultProps.primaryColor;
  const style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1062 794.36",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 643.38,
    y1: 527.87,
    x2: 643.38,
    y2: 439.13,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 601.44,
    y1: 846.53,
    x2: 601.44,
    y2: 825.32,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__c",
    x1: 567.25,
    y1: 842.29,
    x2: 567.25,
    y2: 821.08,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__d",
    x1: 561.22,
    y1: 836.11,
    x2: 561.22,
    y2: 827.95,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__e",
    x1: 597.88,
    y1: 835.38,
    x2: 597.88,
    y2: 826.89,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__f",
    x1: 584.67,
    y1: 835.03,
    x2: 584.67,
    y2: 620.5,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__g",
    x1: 599.49,
    y1: 728.89,
    x2: 599.49,
    y2: 728.32,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__h",
    x1: 600.1,
    y1: 734.92,
    x2: 600.1,
    y2: 733.61,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__i",
    x1: 562.27,
    y1: 733.65,
    x2: 562.27,
    y2: 731.44,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__j",
    x1: 542.46,
    y1: 629.42,
    x2: 542.46,
    y2: 579.01,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__k",
    x1: 522.24,
    y1: 440.19,
    x2: 522.24,
    y2: 398.37,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__l",
    x1: 587.13,
    y1: 513.38,
    x2: 587.13,
    y2: 481.17,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__m",
    x1: 584.99,
    y1: 635.45,
    x2: 584.99,
    y2: 620.5,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__n",
    x1: 582.84,
    y1: 633.82,
    x2: 582.84,
    y2: 496.72,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__o",
    x1: 540.32,
    y1: 582.71,
    x2: 540.32,
    y2: 532.75,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__p",
    x1: 540.3,
    y1: 582.71,
    x2: 540.3,
    y2: 572.18,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__q",
    x1: 581.11,
    y1: 582.41,
    x2: 581.11,
    y2: 570.86,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__r",
    x1: 609.77,
    y1: 606.98,
    x2: 609.77,
    y2: 588.96,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__s",
    x1: 567.9,
    y1: 608.02,
    x2: 567.9,
    y2: 605.46,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__t",
    x1: 604.87,
    y1: 541.68,
    x2: 604.87,
    y2: 524.88,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__u",
    x1: 544.43,
    y1: 525.13,
    x2: 544.43,
    y2: 513.92,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__v",
    x1: 538.8,
    y1: 564.15,
    x2: 538.8,
    y2: 557.55,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__w",
    x1: 539.06,
    y1: 552.57,
    x2: 539.06,
    y2: 547.23,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__x",
    x1: 603.19,
    y1: 655.98,
    x2: 603.19,
    y2: 652.51,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__y",
    x1: 565.55,
    y1: 657.11,
    x2: 565.55,
    y2: 654.23,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__z",
    x1: 599.22,
    y1: 663.17,
    x2: 599.22,
    y2: 662.83,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__A",
    x1: 558.65,
    y1: 671.73,
    x2: 558.65,
    y2: 667.08,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__B",
    x1: 582.1,
    y1: 584.56,
    x2: 582.1,
    y2: 434.29,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__C",
    x1: 542.98,
    y1: 501.81,
    x2: 542.98,
    y2: 477.61,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__D",
    x1: 547.17,
    y1: 562.43,
    x2: 547.17,
    y2: 534.56,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__E",
    x1: 581.02,
    y1: 584.83,
    x2: 581.02,
    y2: 554.96,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__F",
    x1: 618.43,
    y1: 484.19,
    x2: 618.43,
    y2: 462.35,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__G",
    x1: 612.82,
    y1: 534.25,
    x2: 612.82,
    y2: 509.77,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__H",
    x1: 638.86,
    y1: 531.3,
    x2: 638.86,
    y2: 507.86,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__I",
    x1: 647.52,
    y1: 531.06,
    x2: 647.52,
    y2: 508.4,
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    d: "M605.87 111.4c-64.72-2.24-126.36-23.14-185.22-46S303.49 17.18 240.32 5.11c-40.63-7.8-87.1-8.9-119.83 12.89C89 38.96 78.8 75.18 73.33 108.72c-4.12 25.26-6.54 51.85 4.74 75.5 7.84 16.42 21.74 30.22 31.36 45.94 33.47 54.73 9.81 122.21-26.45 175.64-17 25.06-36.75 49-49.88 75.65s-19.2 57.25-7.71 84.47c11.38 27 38.51 47.24 67.9 61.49 59.69 28.95 130 37.23 198.61 41.93 151.83 10.38 304.46 5.89 456.69 1.38 56.34-1.66 112.92-3.35 168.34-12.06 30.78-4.84 62.55-12.52 84.9-31.06 28.36-23.53 35.39-63.37 16.38-92.88-31.88-49.49-120-61.78-142.31-114.89-12.26-29.24.33-61.8 18.16-88.91 38.24-58.17 102.33-109.2 105.7-175.68 2.32-45.66-28.49-91.39-76.13-113-49.93-22.65-119.18-19.8-156 17.68C729.68 98.53 663 113.39 605.87 111.4z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    fill: "#e8e9ed",
    d: "M0 123.48h259.51v259.51H0zM802.49 123.48H1062v259.51H802.49z"
  }), React.createElement("path", {
    d: "M145.39 32.03l-2.59-2.65a.54.54 0 0 0-.41-.18.52.52 0 0 0-.41.18l-17.9 18-6.52-6.51a.56.56 0 0 0-.82 0l-2.61 2.61a.58.58 0 0 0 0 .84l8.22 8.21a2.57 2.57 0 0 0 1.71.84 2.72 2.72 0 0 0 1.71-.81l19.63-19.69a.63.63 0 0 0 0-.84z",
    fill: "#3acc6c",
    opacity: 0.5
  }), React.createElement("path", {
    d: "M129.75 14.88a26.39 26.39 0 1 1-18.68 7.73 26.25 26.25 0 0 1 18.68-7.73m0-4.11a30.53 30.53 0 1 0 30.53 30.52 30.51 30.51 0 0 0-30.53-30.52z",
    fill: primaryColor,
    opacity: 0.5
  }), React.createElement("path", {
    d: "M345.82 117.36l-3.26-3.34a.68.68 0 0 0-.51-.22.66.66 0 0 0-.52.22L319 136.72l-8.21-8.2a.7.7 0 0 0-.51-.22.72.72 0 0 0-.52.22l-3.29 3.29a.72.72 0 0 0 0 1.05l10.34 10.32a3.24 3.24 0 0 0 2.16 1.05 3.43 3.43 0 0 0 2.14-1l24.7-24.84a.79.79 0 0 0 0-1z",
    fill: "#3acc6c",
    opacity: 0.8
  }), React.createElement("path", {
    d: "M326.12 95.76a33.25 33.25 0 1 1-23.52 9.74 33 33 0 0 1 23.52-9.74m0-5.17a38.43 38.43 0 1 0 38.43 38.43 38.42 38.42 0 0 0-38.43-38.43z",
    fill: primaryColor,
    opacity: 0.8
  }), React.createElement("path", {
    d: "M932.24 14.88a26.39 26.39 0 1 1-18.68 7.73 26.25 26.25 0 0 1 18.68-7.73m0-4.11a30.53 30.53 0 1 0 30.53 30.52 30.51 30.51 0 0 0-30.53-30.52z",
    fill: primaryColor,
    opacity: 0.5
  }), React.createElement("path", {
    d: "M734.47 95.76A33.25 33.25 0 1 1 711 105.5a33.06 33.06 0 0 1 23.52-9.74m0-5.17a38.43 38.43 0 1 0 38.43 38.43 38.42 38.42 0 0 0-38.48-38.43z",
    fill: primaryColor,
    opacity: 0.8
  }), React.createElement("path", {
    d: "M529.33 156.74a43.94 43.94 0 1 1-31.1 12.87 43.67 43.67 0 0 1 31.1-12.87m0-6.84a50.81 50.81 0 1 0 50.81 50.81 50.8 50.8 0 0 0-50.81-50.81z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "#f3f5f7",
    d: "M181.52 191.5h289.2v289.2h-289.2zM589.87 191.5h289.2v289.2h-289.2z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M25.93 169.55h96.46v10.72H25.93zM849.19 169.55h96.46v10.72h-96.46z"
  }), React.createElement("path", {
    d: "M701.19 618.41s25.06-44.39 62.8-57.18a77.23 77.23 0 0 0 39.12-29.26 130.64 130.64 0 0 0 11.54-20.79",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M838.38 503.01c-4.3 4.17-24.33 8.49-24.33 8.49s4.92-19.89 9.22-24.07a10.852 10.852 0 0 1 15.11 15.58zM827.05 538.99c-5.88 1.17-25-6.09-25-6.09s14.93-14 20.81-15.19a10.85 10.85 0 0 1 4.22 21.28zM785.8 577.94c-5.66-2-18.53-17.9-18.53-17.9s20-4.57 25.63-2.61a10.852 10.852 0 0 1-7.1 20.51zM748 600.37c-5.92-1-21.3-14.51-21.3-14.51s18.92-7.87 24.83-6.9a10.85 10.85 0 1 1-3.53 21.41zM785.32 517.36c0 6 10.84 23.37 10.84 23.37S807 523.36 807 517.37a10.85 10.85 0 1 0-21.7 0zM741.39 544.18c1.79 5.72 17.34 19.06 17.34 19.06s5.16-19.82 3.37-25.54a10.85 10.85 0 1 0-20.71 6.48zM702.27 576.07c.8 5.94 13.86 21.71 13.86 21.71s8.44-18.66 7.65-24.6a10.852 10.852 0 0 0-21.51 2.89z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M838.38 503.01c-4.3 4.17-24.33 8.49-24.33 8.49s4.92-19.89 9.22-24.07a10.852 10.852 0 0 1 15.11 15.58zM827.05 538.99c-5.88 1.17-25-6.09-25-6.09s14.93-14 20.81-15.19a10.85 10.85 0 0 1 4.22 21.28zM785.8 577.94c-5.66-2-18.53-17.9-18.53-17.9s20-4.57 25.63-2.61a10.852 10.852 0 0 1-7.1 20.51zM748 600.37c-5.92-1-21.3-14.51-21.3-14.51s18.92-7.87 24.83-6.9a10.85 10.85 0 1 1-3.53 21.41zM785.32 517.36c0 6 10.84 23.37 10.84 23.37S807 523.36 807 517.37a10.85 10.85 0 1 0-21.7 0zM741.39 544.18c1.79 5.72 17.34 19.06 17.34 19.06s5.16-19.82 3.37-25.54a10.85 10.85 0 1 0-20.71 6.48zM702.27 576.07c.8 5.94 13.86 21.71 13.86 21.71s8.44-18.66 7.65-24.6a10.852 10.852 0 0 0-21.51 2.89z",
    opacity: 0.25
  }), React.createElement("path", {
    d: "M702.63 617.53s4.93-50.73 34.24-77.72a77.32 77.32 0 0 0 23.91-42.63 130.28 130.28 0 0 0 2.13-23.66",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M781.29 456.43c-2.24 5.56-18.8 17.62-18.8 17.62s-3.57-20.17-1.33-25.73a10.851 10.851 0 0 1 20.13 8.11zM785.51 493.92c-4.9 3.45-25.35 4.58-25.35 4.58s8-18.88 12.87-22.32a10.85 10.85 0 0 1 12.48 17.74zM763.58 546.24c-6 .5-24.19-8.85-24.19-8.85s16.4-12.27 22.37-12.77a10.85 10.85 0 1 1 1.82 21.62zM738.08 582.09c-5.81 1.5-25.35-4.64-25.35-4.64s14.1-14.86 19.9-16.37a10.85 10.85 0 0 1 5.45 21zM738.59 491.06c2.43 5.48 19.38 17 19.38 17s2.89-20.28.47-25.76a10.855 10.855 0 0 0-19.85 8.79zM709.29 533.36c4 4.5 23.58 10.4 23.58 10.4s-3.32-20.22-7.27-24.72a10.852 10.852 0 0 0-16.31 14.32zM686.46 578.38c3.13 5.11 21.47 14.24 21.47 14.24s.16-20.49-3-25.6a10.85 10.85 0 0 0-18.49 11.36z",
    fill: primaryColor
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M218.85 253.23h96.46v10.72h-96.46zM396.6 347.46h57.59v10.72H396.6zM396.6 419.4h85.28v10.72H396.6zM218.85 291.01h96.46v10.72h-96.46zM652.92 253.23h96.46v10.72h-96.46zM652.92 291.01h96.46v10.72h-96.46z"
  }), React.createElement("path", {
    d: "M515.66 215.65l2.7-3.54a14 14 0 0 0 9.72 4c4.56 0 7.94-2.23 7.94-5.84 0-3.92-3.24-6.5-12.22-6.5v-4.07c8 0 11-2.63 11-6.1 0-3.14-2.69-5.1-6.68-5.1a12.86 12.86 0 0 0-8.36 3.42l-2.87-3.42a17.49 17.49 0 0 1 11.45-4.45c6.91 0 12 3.32 12 9.14 0 4.1-3 6.78-7.32 8.26v.22c4.63 1 8.51 4.07 8.51 8.86 0 6.32-6 10.11-13.08 10.11-6.02-.01-10.15-2.3-12.79-4.99z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M737.66 123.5c0-1.92.17-4.37.27-6.29h-.25c-1.1 1.7-2.35 3.39-3.47 5.08l-8 10.26h21.24v4.13h-26.72v-3.5l15.95-21h5.87v33.39h-4.89z",
    fill: primaryColor,
    opacity: 0.8
  }), React.createElement("path", {
    d: "M921.85 51.88l1.81-2.47a9.41 9.41 0 0 0 6.55 2.69c3.22 0 5.75-1.92 5.75-5.07s-2.23-4.85-5.54-4.85a8.47 8.47 0 0 0-4.72 1.39l-1.88-1.21.76-11.81h14v3.25h-10.7l-.59 6.47a9.84 9.84 0 0 1 4.15-.88c4.59 0 8.33 2.36 8.33 7.58s-4.38 8.27-9.11 8.27a12.29 12.29 0 0 1-8.81-3.36z",
    fill: primaryColor,
    opacity: 0.5
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.1,
    d: "M347.16 283.32h357.49v357.49H347.16z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M359.16 266.32h357.49v357.49H359.16z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.5,
    d: "M396.6 305.92h282.6v10.72H396.6z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M396.6 383.43h179.95v10.72H396.6zM396.6 455.38h174.6v10.72H396.6zM396.6 491.35h238.01v10.72H396.6z"
  }), React.createElement("path", {
    d: "M627.52 384.38l-1.23-1.27a.3.3 0 0 0-.2-.08.27.27 0 0 0-.19.08l-8.53 8.6-3.11-3.11a.32.32 0 0 0-.2-.08.29.29 0 0 0-.19.08l-1.25 1.25a.28.28 0 0 0 0 .4l3.92 3.91a1.25 1.25 0 0 0 .82.4 1.26 1.26 0 0 0 .81-.39l9.35-9.39a.32.32 0 0 0 0-.4z",
    fill: "#3acc6c",
    opacity: 0.5
  }), React.createElement("path", {
    d: "M620.07 376.18a12.6 12.6 0 1 1-8.9 3.69 12.5 12.5 0 0 1 8.9-3.69m0-1.95a14.55 14.55 0 1 0 14.54 14.54 14.54 14.54 0 0 0-14.54-14.52zM627.52 456.32l-1.23-1.26a.26.26 0 0 0-.2-.08.24.24 0 0 0-.19.08l-8.53 8.59-3.11-3.1a.28.28 0 0 0-.2-.09.26.26 0 0 0-.19.09l-1.25 1.24a.28.28 0 0 0 0 .4l3.92 3.92a1.25 1.25 0 0 0 .82.4 1.31 1.31 0 0 0 .81-.39l9.35-9.4a.32.32 0 0 0 0-.4z",
    fill: "#3acc6c",
    opacity: 0.5
  }), React.createElement("path", {
    d: "M620.07 448.18a12.6 12.6 0 1 1-8.9 3.69 12.5 12.5 0 0 1 8.9-3.69m0-2a14.55 14.55 0 1 0 14.54 14.55 14.54 14.54 0 0 0-14.54-14.55z",
    fill: "#3acc6c",
    opacity: 0.5
  }), React.createElement("ellipse", {
    cx: 512.51,
    cy: 782.38,
    rx: 71.41,
    ry: 11.98,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M130.91 693.37s3.72 4.87-1.72 12.23-9.94 13.56-8.12 18.15c0 0 8.21-13.66 14.9-13.85s2.29-8.31-5.06-16.53z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M130.91 693.37a6.09 6.09 0 0 1 .76 1.53c6.52 7.67 10 14.82 3.73 15-5.84.17-12.85 10.61-14.53 13.25a4.69 4.69 0 0 0 .2.6s8.21-13.66 14.9-13.85 2.29-8.31-5.06-16.53z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M137.83 699.58c0 1.72-.19 3.11-.43 3.11s-.43-1.39-.43-3.11.24-.91.48-.91.38-.8.38.91z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M140.21 701.63c-1.51.82-2.82 1.32-2.93 1.11s1-1 2.52-1.87.91-.22 1 0 .91-.06-.59.76z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M111.23 693.37s-3.73 4.87 1.72 12.23 9.93 13.56 8.12 18.15c0 0-8.22-13.66-14.9-13.85s-2.3-8.31 5.06-16.53z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M111.23 693.37a6.09 6.09 0 0 0-.76 1.53c-6.53 7.67-10 14.82-3.73 15 5.84.17 12.85 10.61 14.53 13.25-.06.2-.12.4-.2.6 0 0-8.22-13.66-14.9-13.85s-2.3-8.31 5.06-16.53z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M104.3 699.58c0 1.72.19 3.11.43 3.11s.43-1.39.43-3.11-.24-.91-.48-.91-.38-.8-.38.91z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M101.93 701.63c1.5.82 2.81 1.32 2.93 1.11s-1-1-2.52-1.87-.91-.22-1 0-.92-.06.59.76z",
    fill: "#ffd037"
  }), React.createElement("ellipse", {
    cx: 121.07,
    cy: 755.04,
    rx: 38.95,
    ry: 5.98,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M141.12 717.18l-.19 1.53-.26 2.14-.11.9-.26 2.15-.11.9-.27 2.14-3 24.44c-.26 2.18-3.83 3.88-8.13 3.88h-15.47c-4.3 0-7.86-1.7-8.12-3.88l-3-24.44-.26-2.14-.11-.9-.26-2.15-.11-.9-.26-2.14-.2-1.53c-.15-1.23 1.78-2.27 4.21-2.27h31.68c2.45 0 4.38 1.04 4.23 2.27z",
    fill: "#65617d"
  }), React.createElement("path", {
    fill: "#9d9cb5",
    d: "M140.93 718.7l-.26 2.15h-39.2l-.27-2.15h39.73zM140.56 721.75l-.26 2.15h-38.46l-.26-2.15h38.98zM140.19 724.79l-.27 2.15h-37.71l-.26-2.15h38.24z"
  }), React.createElement("path", {
    d: "M590.84 461.79c-.67-1.37-6-19-6-19l-10.27-26.07s-6.23-34.31-15.53-25.75 5 29.1 5 29.1 5.87 15 5.57 18 3.27 14 3.27 14l-1.16 6.32c-1.51-.1-2.49-.1-2.49-.1s-.92 1.32-1.8 1.41a.83.83 0 0 1-.44-.06c-1-.45-4.31-.36-6-.36a13.44 13.44 0 0 1-4.49-1.44c-.58-1.16-3.86-1.85-6.77-2.24-2.21-5.5-5.32-10.85-5.75-16.59a7.17 7.17 0 0 1 .88-4.52 5.65 5.65 0 0 1 .66-.82c.81-.82 1.8-1.54 2.7-2.3.45-.38.86-.77 1.25-1.17 7.63-7.4 6.42-18.86-.5-26.79-8-9.17-44.08-28.9-55-12-1.52 2.36-1.57 5.09-2 7.71a32.14 32.14 0 0 1-8.62 17c-3.62 3.85-8.37 7.4-10.45 11.76l-.07-.16a11.65 11.65 0 0 0-1.08 3c-1.05 5.31 2.53 10.42 4.41 15.59a28 28 0 0 1 1.38 5.42l.12-1.14a35.22 35.22 0 0 1 .47 8c-13.1 2.68-13.11 25.26-13.11 25.26s-1.61 9-1.34 12.21.27 10.23.27 11.94-1.62 12.21-1.8 13.47c-.23 1.39-2.69 8.05 3.25 9.55.41.11.85.2 1.3.28.25 5.39.72 16.7.31 19.2 0 0 2.16 15.18 3.95 19a45.06 45.06 0 0 0 4 6.45 7 7 0 0 1-.91 2.61c-.91 1.33-.44 2.42 1.09 2.89q-.07.69-.18 1.56c-.65 5.86-1.63 17.49 0 23.39 2.29 8.08 2.42 10.77 2.42 10.77a8 8 0 0 0 .94 3.77c1 1.35 2.7 13.87 2.7 15.89s4.58 20.2 3.23 24.51-.27 10.37-.27 10.37-.81 10.64-1.75 12.93-1.35 39.19.13 48.75 2.43 17.51 2.43 17.51-1 8.75-.14 10 2.29 8.49 1.21 8.89-1.61 3.37-1.61 3.37a29.63 29.63 0 0 0 1.84 2.51 10.16 10.16 0 0 1-1.22-.52c.43.61 1.07 1.45 1.85 2.37l-.73 9.68a1.62 1.62 0 0 0 1.2 1.7 13.44 13.44 0 0 0 13.38-3.79c6.73-6.87 9-5.92 10.24-10.1.12-.45.24-.88.33-1.3a4.37 4.37 0 0 0-6.19-4.9c.43-3 .77-6.29.44-8.18-.67-3.9-.54-14.14-.54-14.14l-.94-49s1.75-9.69 3.77-13.46 1.75-17 1.75-17l2.29-43.37 2.28-21s2.15-7.27 4.84.81c0 0-1.48 16.29-.8 20.2s1.61 22.89.94 27.07-3.64 27.07-1.75 32.86 3.9 12.79 3.5 15.08-1.75 52-1.75 52 3.63 9.56.94 12.66-.13 15.49-.13 15.49.32.23.88.56l-.08 1-.84 11.14a1.63 1.63 0 0 0 1.2 1.7 13.46 13.46 0 0 0 13.38-3.79c6.73-6.87 9-5.93 10.24-10.1.12-.45.24-.89.34-1.31a4.38 4.38 0 0 0-7.06-4.35.93.93 0 0 1-.15.13c-.17.15-.35.28-.53.41l-.26.17c.67-3.08 1.65-8.33 1.19-10.81-.67-3.64.67-14.68.67-14.68s3.91-13.2 4-18.45 1.08-42 1.08-42-.13-17.1.41-21.27 4.84-40.27 9.15-51c3.31-8.26 4.79-29.31 3.91-40-.05-.54-.1-1-.15-1.52 5.27-3.96 5.83-10.48 5.83-10.48s-4.85-9.34-9.52-13.29-5.75-10.77-5.57-13.65a7.09 7.09 0 0 0-1.61-4.84s-2.16-7-3.6-7.72a1 1 0 0 1-.31-.24c-1-1.06-.23-4.07-.23-4.07v-.09c.16-.7 1.21-5.22.87-6.38s.18-7.18.18-7.18 3.42-10.23 2.88-18.31 7-7.37 7-7.37l23.29-.24h2.65a19.52 19.52 0 0 0 3-3.21 6.42 6.42 0 0 0 5.15-1.26c4.94-4.52 4.33-13.15 3.66-14.54zm-108.31 70l.17-4.1.91.78a6.56 6.56 0 0 1 0 3.28 3.5 3.5 0 0 1-2 2.28 2.23 2.23 0 0 0-.33.2l-.23-2.34c.95-.06 1.48-.11 1.48-.11z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M638.9 522.56s13.26 8.53 18.28 4 4.4-13.27 3.72-14.65-6.08-19.13-6.08-19.13l-10.43-26.28s-6.34-34.59-15.8-26 5.1 29.33 5.1 29.33 6 15.13 5.66 18.16 3.32 14.13 3.32 14.13z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__a)"
  }), React.createElement("path", {
    d: "M614.17 830.73c-.1.43-.21.87-.35 1.32-1.23 4.21-3.56 3.26-10.4 10.18a13.73 13.73 0 0 1-13.6 3.82 1.64 1.64 0 0 1-1.22-1.71l.86-11.23.41-5.41s10.89 3.06 16.44-.81c.18-.13.36-.26.53-.41l.16-.13a4.45 4.45 0 0 1 7.17 4.38z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    d: "M580 826.49c-.09.43-.21.87-.34 1.32-1.23 4.21-3.56 3.26-10.4 10.18a13.77 13.77 0 0 1-13.6 3.83 1.63 1.63 0 0 1-1.22-1.72l.85-11.23.42-5.41s10.89 3.06 16.43-.81c.19-.13.36-.26.54-.41l.16-.13a4.44 4.44 0 0 1 7.16 4.38z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__c)"
  }), React.createElement("path", {
    d: "M568.72 828.18l.45 5.83c-6.26 6.2-13.7-3-15.9-6.06 5.73 2.94 15.45.23 15.45.23z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__d)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M605.47 830.55l.83-.54c-5.72 8.62-14.2 4.64-16.84 3.1l.41-5.41s10.89 3.06 16.44-.81c-.44 2.11-.84 3.66-.84 3.66z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__e)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M622.86 667.49c-4.38 10.86-8.76 47.25-9.31 51.46s-.41 21.45-.41 21.45L612 782.76c-.13 5.3-4.1 18.6-4.1 18.6s-1.37 11.14-.69 14.8-1.78 13.31-1.78 13.31l.83-.54c-6.85 10.31-17.66 2.57-17.66 2.57s-2.6-12.49.13-15.61-.95-12.76-.95-12.76 1.36-50.1 1.78-52.41-1.56-9.37-3.56-15.21 1.09-28.92 1.78-33.13-.28-23.35-1-27.29.82-20.37.82-20.37c-2.74-8.14-4.93-.81-4.93-.81l-2.19 21.32-2.25 43.77s.28 13.3-1.78 17.1-3.83 13.58-3.83 13.58l1 49.42s-.14 10.32.55 14.26-1.51 14.12-1.51 14.12c-7.66 17.92-20-1.49-20-1.49s.54-3 1.64-3.4-.41-7.74-1.23-9 .13-10 .13-10-.95-8-2.46-17.66-1.09-46.84-.14-49.15 1.78-13 1.78-13-1.09-6.11.28-10.46-3.29-22.67-3.29-24.71-1.78-14.66-2.74-16a8 8 0 0 1-1-3.8s-.14-2.72-2.47-10.86c-1.7-6-.7-17.68 0-23.58.24-2.19.44-3.58.44-3.58s78.57-12.63 81.72-9.77c.74.66 1.23 3 1.51 6.26.89 10.66-.62 31.89-3.97 40.21z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__f)"
  }), React.createElement("path", {
    d: "M593.15 728.54c.37 0 9 .73 12.23.09s-12.23-.09-12.23-.09z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__g)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M593.79 733.61s12 2.08 12.6 1-12.6-1-12.6-1z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__h)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M557.2 731.44s6.2.27 9.58 1.81-9.58-1.81-9.58-1.81z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__i)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M534.66 579.19s1 18.92.46 22.26c0 0 2.19 15.3 4 19.19a55.12 55.12 0 0 0 5.75 8.78l5.38-37.56L549 579z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__j)"
  }), React.createElement("ellipse", {
    cx: 522.24,
    cy: 419.28,
    rx: 21.08,
    ry: 20.91,
    fill: "url(#prefix__k)"
  }), React.createElement("path", {
    d: "M580.29 481.88s-6.57 12.76-13.14 18.74 39.42 12.76 40.51 12.76-8.21-27.15-6.57-30.41-20.8-1.09-20.8-1.09z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__l)"
  }), React.createElement("path", {
    d: "M626.83 627.18a13.66 13.66 0 0 1-3.38 1.88c-8.39 3.26-17.52 7.79-23.73 6s-19.34 0-19.34 0-26.47-2.18-31.76-.91a10.26 10.26 0 0 1-5.46.14c.24-2.19.44-3.58.44-3.58s78.57-12.63 81.72-9.77c.74.64 1.23 2.95 1.51 6.24z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__m)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M632.58 615.12s-.73 9-9.13 12.31-17.52 7.79-23.73 6-19.34 0-19.34 0-26.47-2.18-31.76-.91-8-.36-6.39-2.72 1.47-10.13 1.47-13.39-1.83-16.48-.19-18.83 3.1-11.4 6.39-12.85a3.55 3.55 0 0 0 2.05-2.3 6.47 6.47 0 0 0 0-3.31s-.55-.45-1.32-1.13c-1.93-1.71-5.21-4.89-4.16-5.93 1.46-1.45 0-10.87 0-10.87s-3.47-7.24-2.19-9.95-11.13-17-11.13-17 0-24.62 15-25.71c0 0 10.58.37 11.86-4.34s9.67-7.43 9.67-7.43l19.16 4.17s17 3.62 20.08 1.45 5.48 2.89 5.48 2.89 10.58.55 11.68 2.72-3.47 23.35-3.47 23.35-7.67-.72-7.12 7.43-2.92 18.46-2.92 18.46-.55 6-.18 7.24-.72 5.72-.89 6.43v.09s-.76 3 .23 4.11a1.49 1.49 0 0 0 .32.24c1.46.72 3.65 7.78 3.65 7.78a7.13 7.13 0 0 1 1.65 4.89c-.18 2.9.91 9.77 5.65 13.76s9.58 13.35 9.58 13.35z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__n)"
  }), React.createElement("path", {
    d: "M551.17 573.21v.77l-.34 8.47s-11.22.9-17.34-.64-3.53-8.23-3.29-9.63c.18-1.27 1.82-11.86 1.82-13.58s0-8.78-.27-12 1.37-12.31 1.37-12.31l1.18-1.45 12.87 4.89z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__o)"
  }), React.createElement("path", {
    d: "M551.15 574l-.34 8.47s-11.22.9-17.34-.64-3.53-8.23-3.29-9.63z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__p)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M552 582.41a6.47 6.47 0 0 0 0-3.31s-.55-.45-1.32-1.13c9.67-1.33 47.94-6.55 60.84-7.11v.09s-.76 3 .23 4.11z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__q)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M612.87 589s2.37 13.31-6.48 18c0 0 5.02-6.63 6.48-18z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__r)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M554.92 607.34s21.35-3.62 25.55-.82-25.55.82-25.55.82z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__s)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M605.47 524.88s-3.28 13.39-.82 16.47.82-16.47.82-16.47z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__t)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M543.6 513.92s3 5 1.19 10.14-1.19-10.14-1.19-10.14z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__u)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M537.4 557.55s3.83 2.27 2.55 5.8-2.55-5.8-2.55-5.8z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__v)"
  }), React.createElement("path", {
    d: "M537 547.23s3.56 1.91 4 4.71-4-4.71-4-4.71z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__w)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M589.78 655.49s22.36 2.27 26.83-3c0 .02-20.17 4-26.83 3z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__x)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M551.18 654.23s24 5.61 28.74 1.17c0 0-20.62 1.54-28.74-1.17z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__y)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M591.51 662.83s10 0 14.69.27-14.69-.27-14.69-.27z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__z)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M552.82 667.08s4.93 5.52 10.49 4.53-10.49-4.53-10.49-4.53z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__A)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M562.5 441c-1.55 2.38-1.6 5.13-2 7.77a32.32 32.32 0 0 1-8.76 17.19c-4.38 4.62-10.39 8.8-11.52 14.44-1.07 5.36 2.57 10.51 4.48 15.72 5 13.75-2 28.16-4.05 42.35-.56 3.92.12 8.93 5 10.23 1.52.41 3.26.36 4.62 1 1.84.87 2.4 2.68 2.74 4.31a65.67 65.67 0 0 1 1.25 17.73c-.22 3.34-.46 7.17 2.71 9.46a16.13 16.13 0 0 0 5.26 2.08c5 1.34 11.47 2.41 14.84-.72 1.42-1.31 2-3.17 3.71-4.21 2.64-1.55 6.39-.5 9.72-.34a17.65 17.65 0 0 0 15.81-8.42c2.69-4.81 2.46-10.29 1.46-15.47s-2.72-10.3-2.85-15.54a9 9 0 0 1 1.18-5.27c2-3.12 6.77-4.54 10-7 6.06-4.6 6-12.14 3.84-18.45s-6.16-12.34-6.65-18.86a7.16 7.16 0 0 1 .9-4.56 17.78 17.78 0 0 1 3.68-3.42c8.85-7.41 7.81-19.59.49-27.92-8.12-9.27-44.81-29.17-55.86-12.1z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__B)"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M545.82 501.81a34.07 34.07 0 0 0-1.39-16.32c-1-2.63-2.37-5.25-3.38-7.88a11.19 11.19 0 0 0-1.1 3c-1.08 5.35 2.57 10.5 4.48 15.72a28.42 28.42 0 0 1 1.39 5.48z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__C)"
  }), React.createElement("path", {
    d: "M554 561.11a65.3 65.3 0 0 0-1.26-17.73c-.34-1.63-.9-3.44-2.73-4.31-1.37-.65-3.11-.6-4.63-1a6.31 6.31 0 0 1-4.26-3.5c-.27 1.38-.52 2.76-.72 4.13-.57 3.92.11 8.93 5 10.23 1.52.41 3.26.36 4.63 1 1.83.87 2.39 2.68 2.73 4.31a65.14 65.14 0 0 1 1.18 8.19c-.02-.43.06-.88.06-1.32z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__D)"
  }), React.createElement("path", {
    d: "M606 559a17.64 17.64 0 0 1-15.8 8.42c-3.33-.16-7.08-1.21-9.72.34-1.76 1-2.3 2.9-3.71 4.21-3.37 3.13-9.84 2.06-14.84.72a16 16 0 0 1-5.26-2.08 6.46 6.46 0 0 1-2.59-4.18c0 1.86 0 3.73-.12 5.59-.22 3.33-.46 7.16 2.71 9.45a16 16 0 0 0 5.26 2.08c5 1.35 11.47 2.41 14.84-.72 1.41-1.31 2-3.16 3.71-4.2 2.64-1.56 6.39-.51 9.72-.34a17.62 17.62 0 0 0 15.8-8.43c2.59-4.62 2.48-9.86 1.58-14.86a16.18 16.18 0 0 1-1.58 4z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__E)"
  }), React.createElement("path", {
    d: "M617.59 470.4a17.84 17.84 0 0 0-3.69 3.42 7.17 7.17 0 0 0-.89 4.56 23.57 23.57 0 0 0 1.25 5.81 25 25 0 0 1 3.33-2.93c6-5 7.44-12.2 5.5-18.91a17.37 17.37 0 0 1-5.5 8.05z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__F)"
  }), React.createElement("path", {
    d: "M615.82 515.69c-3.24 2.45-8 3.87-10 7a8.93 8.93 0 0 0-1.18 5.27 36.29 36.29 0 0 0 .78 6.3 7.14 7.14 0 0 1 .4-.71c2-3.11 6.76-4.54 10-7 5.53-4.2 6-10.85 4.36-16.78a12.67 12.67 0 0 1-4.36 5.92z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__G)"
  })), React.createElement("path", {
    d: "M657.49 517.91c-3.74 9.41-8.58 13.12-8.58 13.12h-2.69l-23.68.24-2.74-7.42 3.84-16 2.36.15a13.7 13.7 0 0 0 4.56 1.45c1.73 0 5.11-.09 6.11.36a.79.79 0 0 0 .45.06c.89-.09 1.84-1.42 1.84-1.42s22.27.04 18.53 9.46z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__H)"
  }), React.createElement("path", {
    d: "M657.49 517.91c-3.74 9.41-8.58 13.12-8.58 13.12h-2.69c1.4-3.73 4.36-11.39 5.52-13.15s-8.81-5.84-14.61-8.09c.89-.09 1.84-1.42 1.84-1.42s22.26.12 18.52 9.54z",
    transform: "translate(-69 -52.82)",
    fill: "url(#prefix__I)",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M569.2 472.38s13 8.46 18 3.94 4.33-13.16 3.66-14.53-6-19-6-19l-10.27-26.07s-6.23-34.31-15.53-25.75 5 29.1 5 29.1 5.87 15 5.57 18 3.27 14 3.27 14z",
    fill: "#efb7b9"
  }), React.createElement("path", {
    d: "M544.87 778.04c-.1.42-.22.86-.34 1.31-1.22 4.17-3.51 3.23-10.24 10.1a13.46 13.46 0 0 1-13.38 3.79 1.63 1.63 0 0 1-1.2-1.7l.84-11.14.41-5.36s10.72 3 16.17-.81c.18-.13.36-.26.53-.41a.93.93 0 0 0 .15-.13 4.38 4.38 0 0 1 7.06 4.35zM511.22 773.84c-.09.42-.21.85-.33 1.3-1.22 4.18-3.51 3.23-10.24 10.1a13.44 13.44 0 0 1-13.38 3.79 1.62 1.62 0 0 1-1.2-1.7l.84-11.14.41-5.36s10.72 3 16.17-.81a6.14 6.14 0 0 0 .53-.4l.15-.14a4.38 4.38 0 0 1 7.05 4.36z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M500.15 775.51l.44 5.79c-6.15 6.14-13.48-3-15.64-6 5.66 2.88 15.2.21 15.2.21zM536.31 777.86l.81-.53c-5.62 8.54-14 4.6-16.57 3.07l.41-5.36s10.72 3 16.17-.81c-.43 2.09-.82 3.63-.82 3.63z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M553.41 616.18c-4.31 10.77-8.62 46.86-9.15 51s-.41 21.27-.41 21.27l-1.08 42c-.13 5.25-4 18.45-4 18.45s-1.34 11-.67 14.68-1.75 13.2-1.75 13.2l.81-.54c-6.73 10.23-17.37 2.56-17.37 2.56s-2.56-12.39.13-15.49-.94-12.66-.94-12.66 1.35-49.69 1.75-52-1.62-9.29-3.5-15.08 1.08-28.69 1.75-32.86-.27-23.17-.94-27.07.8-20.2.8-20.2c-2.69-8.08-4.84-.81-4.84-.81l-2.16 21.14-2.33 43.41s.27 13.19-1.75 17S504 697.6 504 697.6l.94 49s-.13 10.24.54 14.14-1.48 14-1.48 14c-7.54 17.77-19.66-1.48-19.66-1.48s.54-3 1.61-3.37-.4-7.68-1.21-8.89.14-10 .14-10-1-7.95-2.43-17.51-1.07-46.46-.13-48.75 1.75-12.93 1.75-12.93-1.08-6.06.27-10.37-3.23-22.49-3.23-24.51-1.75-14.54-2.7-15.89a8 8 0 0 1-.94-3.77s-.13-2.69-2.42-10.77c-1.67-5.9-.69-17.53 0-23.39.24-2.17.44-3.55.44-3.55s77.3-12.52 80.4-9.69c.72.66 1.21 3 1.48 6.21.83 10.74-.65 31.79-3.96 40.1z",
    fill: "#444053"
  }), React.createElement("path", {
    d: "M524.19 676.68c.36 0 8.89.72 12 .09s-12-.09-12-.09zM524.82 681.71s11.76 2.07 12.39 1-12.39-1-12.39-1zM488.82 679.56s6.1.27 9.42 1.79-9.42-1.79-9.42-1.79z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M466.64 528.55s1 18.76.45 22.08c0 0 2.16 15.18 3.95 19a55.07 55.07 0 0 0 5.66 8.71l5.3-37.22-1.25-12.75z",
    fill: "#efb7b9"
  }), React.createElement("circle", {
    cx: 522.31,
    cy: 422.34,
    r: 20.74,
    fill: "#efb7b9"
  }), React.createElement("path", {
    d: "M511.53 432.04s-6.46 12.65-12.93 18.58 38.79 12.66 39.87 12.66-8.08-26.94-6.47-30.17-20.47-1.07-20.47-1.07z",
    fill: "#efb7b9"
  }), React.createElement("path", {
    d: "M557.32 576.18a13.55 13.55 0 0 1-3.32 1.87c-8.26 3.23-17.24 7.72-23.35 5.92s-19 0-19 0-26-2.15-31.24-.9a10.07 10.07 0 0 1-5.41.11c.24-2.17.44-3.55.44-3.55s77.3-12.52 80.4-9.69c.72.66 1.21 2.95 1.48 6.24z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M563 564.18s-.72 9-9 12.21-17.24 7.72-23.35 5.93-19 0-19 0-26-2.16-31.24-.9-7.9-.36-6.29-2.7 1.44-10 1.44-13.28-1.8-16.34-.18-18.68 3-11.31 6.29-12.75a3.5 3.5 0 0 0 2-2.28 6.56 6.56 0 0 0 0-3.28s-.54-.45-1.3-1.12c-1.9-1.7-5.12-4.85-4.08-5.88 1.43-1.44 0-10.78 0-10.78s-3.42-7.18-2.16-9.87-11-16.88-11-16.88 0-24.42 14.73-25.5c0 0 10.41.36 11.67-4.31s9.52-7.36 9.52-7.36l18.85 4.13s16.7 3.59 19.75 1.44 5.35 2.86 5.35 2.86 10.41.54 11.49 2.69-3.41 23.16-3.41 23.16-7.54-.71-7 7.37-2.88 18.31-2.88 18.31-.54 5.93-.18 7.18-.71 5.68-.87 6.38v.09s-.74 3 .23 4.07a1 1 0 0 0 .31.24c1.44.71 3.6 7.72 3.6 7.72a7.09 7.09 0 0 1 1.61 4.84c-.18 2.88.9 9.7 5.57 13.65s9.53 13.3 9.53 13.3z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M482.89 522.62v.76l-.33 8.4s-11 .9-17-.63-3.48-8.16-3.25-9.55c.18-1.26 1.8-11.77 1.8-13.47s0-8.71-.27-11.94 1.34-12.21 1.34-12.21l1.17-1.44 12.66 4.85z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M482.86 523.38l-.33 8.4s-11 .9-17-.63-3.48-8.16-3.25-9.55z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M483.66 531.74a6.56 6.56 0 0 0 0-3.28s-.54-.45-1.3-1.12c9.52-1.32 47.17-6.49 59.86-7v.09s-.74 3 .23 4.07zM543.58 538.24s2.34 13.2-6.37 17.87c0 0 4.94-6.55 6.37-17.87zM486.57 556.47s21-3.59 25.14-.81-25.14.81-25.14.81zM536.31 474.68s-3.23 13.29-.81 16.34.81-16.34.81-16.34zM475.44 463.82s3 4.93 1.17 10.05-1.17-10.05-1.17-10.05z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M469.34 507.09s3.77 2.25 2.51 5.75-2.51-5.75-2.51-5.75z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M469 496.86s3.5 1.88 3.95 4.66-3.95-4.66-3.95-4.66zM520.87 604.23s22 2.25 26.39-3c0 .04-19.84 3.95-26.39 3zM482.89 602.97s23.61 5.57 28.28 1.17c0 .04-20.29 1.53-28.28-1.17zM522.57 611.5s9.88 0 14.46.27-14.46-.27-14.46-.27zM484.51 615.72s4.85 5.48 10.32 4.49-10.32-4.49-10.32-4.49z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M494 391.44c-1.52 2.36-1.57 5.09-2 7.71a32.14 32.14 0 0 1-8.62 17c-4.3 4.58-10.21 8.73-11.33 14.32-1.05 5.31 2.53 10.42 4.41 15.59 5 13.63-2 27.93-4 42-.56 3.89.11 8.86 4.9 10.15 1.5.4 3.21.35 4.56 1 1.8.86 2.35 2.66 2.68 4.27a65.47 65.47 0 0 1 1.24 17.59c-.22 3.31-.46 7.11 2.66 9.39a16.1 16.1 0 0 0 5.18 2.06c4.92 1.33 11.28 2.38 14.6-.72 1.39-1.3 1.91-3.14 3.65-4.17 2.6-1.54 6.29-.5 9.56-.34a17.33 17.33 0 0 0 15.55-8.35c2.65-4.78 2.42-10.2 1.44-15.34s-2.68-10.22-2.8-15.42a8.91 8.91 0 0 1 1.16-5.22c2-3.1 6.65-4.51 9.84-6.94 6-4.56 5.94-12 3.78-18.3s-6.07-12.24-6.55-18.71a7.17 7.17 0 0 1 .88-4.52 18.18 18.18 0 0 1 3.71-3.31c8.71-7.35 7.68-19.43.48-27.69-7.98-9.2-44.08-28.93-54.98-12.05z",
    fill: "#e3787d"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M477.63 451.8a34.17 34.17 0 0 0-1.38-16.19c-.94-2.61-2.32-5.2-3.33-7.81a11.65 11.65 0 0 0-1.08 3c-1.05 5.31 2.53 10.42 4.41 15.59a28 28 0 0 1 1.38 5.41zM485.65 510.62a65.47 65.47 0 0 0-1.24-17.59c-.33-1.61-.88-3.41-2.68-4.27-1.35-.65-3.06-.6-4.56-1a6.26 6.26 0 0 1-4.19-3.47c-.27 1.36-.51 2.73-.71 4.09-.56 3.89.11 8.86 4.9 10.15 1.5.4 3.21.35 4.56 1 1.8.87 2.35 2.66 2.68 4.28a65.86 65.86 0 0 1 1.16 8.12c.02-.44.05-.88.08-1.31zM536.85 508.49a17.32 17.32 0 0 1-15.55 8.35c-3.27-.16-7-1.2-9.56.34-1.73 1-2.26 2.87-3.65 4.17-3.32 3.1-9.68 2.05-14.6.72a15.75 15.75 0 0 1-5.17-2.07 6.52 6.52 0 0 1-2.56-4.14c0 1.84 0 3.69-.11 5.53-.22 3.31-.46 7.11 2.67 9.39a16 16 0 0 0 5.17 2.06c4.92 1.33 11.28 2.38 14.6-.71 1.39-1.31 1.92-3.15 3.65-4.18 2.6-1.54 6.29-.5 9.56-.34a17.32 17.32 0 0 0 15.55-8.35c2.55-4.59 2.44-9.78 1.55-14.74a16.27 16.27 0 0 1-1.55 3.97zM548.23 420.65a17.62 17.62 0 0 0-3.63 3.39 7.17 7.17 0 0 0-.88 4.52 24.18 24.18 0 0 0 1.24 5.77 23.63 23.63 0 0 1 3.27-2.91c5.89-5 7.32-12.1 5.41-18.75a17.18 17.18 0 0 1-5.41 7.98zM546.49 465.57c-3.19 2.43-7.84 3.84-9.84 6.93a9 9 0 0 0-1.16 5.23 36.69 36.69 0 0 0 .77 6.25 4.8 4.8 0 0 1 .39-.7c2-3.1 6.65-4.51 9.84-6.94 5.44-4.17 5.9-10.76 4.29-16.64a12.64 12.64 0 0 1-4.29 5.87z"
  })), React.createElement("path", {
    d: "M587.49 467.77c-3.68 9.34-8.45 13-8.45 13h-2.65l-23.29.24-2.69-7.36 3.77-15.89 2.33.09a13.44 13.44 0 0 0 4.49 1.44c1.71 0 5-.09 6 .36a.83.83 0 0 0 .44.06c.88-.09 1.8-1.41 1.8-1.41s21.92.13 18.25 9.47z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M587.49 467.77c-3.68 9.34-8.45 13-8.45 13h-2.65c1.39-3.7 4.3-11.29 5.44-13s-8.67-5.79-14.37-8c.88-.09 1.8-1.41 1.8-1.41s21.9.07 18.23 9.41z",
    opacity: 0.1
  }));
};

UndrawSetupWizard.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawSetupWizard;